var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C20.1799 0 26 5.8178 26 12.9949C26.0027 16.4066 24.663 19.6826 22.2702 22.1155C19.8773 24.5484 16.6233 25.943 13.2106 25.9983C9.79796 26.0536 6.50044 24.7651 4.03 22.4109C1.55955 20.0568 0.114385 16.826 0.00650015 13.4159L0 12.9949L0.00519993 12.631C0.1976 5.62288 5.941 0 13 0ZM13.013 16.8933L12.8479 16.9024C12.5319 16.94 12.2407 17.0921 12.0294 17.3299C11.8181 17.5677 11.7014 17.8747 11.7014 18.1928C11.7014 18.5109 11.8181 18.8179 12.0294 19.0557C12.2407 19.2935 12.5319 19.4456 12.8479 19.4832L13 19.4923L13.1651 19.4832C13.4811 19.4456 13.7723 19.2935 13.9836 19.0557C14.1948 18.8179 14.3115 18.5109 14.3115 18.1928C14.3115 17.8747 14.1948 17.5677 13.9836 17.3299C13.7723 17.0921 13.4811 16.94 13.1651 16.9024L13.013 16.8933ZM13 6.49743C12.6816 6.49747 12.3743 6.61433 12.1363 6.82583C11.8984 7.03733 11.7464 7.32877 11.7091 7.64488L11.7 7.79692V12.9949L11.7091 13.1469C11.7467 13.4627 11.8988 13.7538 12.1368 13.965C12.3747 14.1762 12.6818 14.2929 13 14.2929C13.3182 14.2929 13.6253 14.1762 13.8632 13.965C14.1012 13.7538 14.2533 13.4627 14.2909 13.1469L14.3 12.9949V7.79692L14.2909 7.64488C14.2536 7.32877 14.1016 7.03733 13.8637 6.82583C13.6257 6.61433 13.3184 6.49747 13 6.49743Z",
    fill: "#FF740F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.aea329c03c3d3289d7742710ee2b9d5a.svg";
export { ForwardRef as ReactComponent };